var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VBlock',{staticClass:"banner-wrapper",attrs:{"onClick":_vm.openWebview}},[_c('div',{staticClass:"bannerImage",style:(_vm.backgroundImage)})])}
var staticRenderFns = []

export { render, staticRenderFns }